// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M16 4H8V1H6V4H2V9H22V4H18V1H16V4Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 13V10.9999H2V22H12V21C12 16.5817 15.5817 13 20 13H22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23.4143 18.2133L19.2867 14.0857L14 19.3724L14.0012 23.4999H18.1277L23.4143 18.2133ZM17.2007 19.0001L18.4999 20.2993L17.2993 21.4999H16.0006L16.0002 20.2006L17.2007 19.0001Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-calendar-edit-filled')
export default class CalendarEditFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'calendar-edit-filled',
    }
  }
}
